export const IMAGE_CLIPBOARD_META_TYPE = "web application/x-ed-image-meta";

const GENERIC_CLIPBOARD_IMAGE_NAMES = [
  "image.png",
  "image.jpeg",
  "image.jpg",
  "image.gif",
  "image.webp",
  "image.bmp",
];

export function buildImageClipboardMetaPayload(fileName, title) {
  return {
    type: IMAGE_CLIPBOARD_META_TYPE,
    blob: new Blob([JSON.stringify({ fileName, title })], {
      type: "application/x-ed-image-meta",
    }),
  };
}

export function sanitizePastedFileName(name) {
  return String(name)
    .replace(/[\\/:*?"<>|]/g, "-")
    .replace(/\s+/g, " ")
    .trim();
}

export function resolvePastedImageFileName({ blob, plainText, metaFileName, ext }) {
  if (metaFileName) {
    return sanitizePastedFileName(metaFileName);
  }

  const normalizedPlainText = (plainText || "").trim();
  if (normalizedPlainText && !normalizedPlainText.includes("\n")) {
    const sanitized = sanitizePastedFileName(normalizedPlainText);
    if (/\.(png|jpe?g|gif|webp|bmp)$/i.test(sanitized)) {
      return sanitized;
    }
    if (sanitized && !/^https?:\/\//i.test(sanitized)) {
      return `${sanitized}${ext}`;
    }
  }

  const blobName = blob && blob.name ? blob.name.toLowerCase() : "";
  if (blobName && !GENERIC_CLIPBOARD_IMAGE_NAMES.includes(blobName)) {
    return blob.name;
  }

  return `粘贴图片_${Date.now()}${ext}`;
}

export async function readImageClipboardMeta(items) {
  if (!items || !items.length) {
    return "";
  }

  for (let i = 0; i < items.length; i += 1) {
    const item = items[i];
    if (
      item.kind !== "string" ||
      (!item.type.includes("x-ed-image-meta") &&
        item.type !== "application/x-ed-image-meta")
    ) {
      continue;
    }

    const metaText = await new Promise((resolve) => {
      item.getAsString((text) => resolve(text || ""));
    });

    if (!metaText) {
      continue;
    }

    try {
      const meta = JSON.parse(metaText);
      if (meta.fileName) {
        return meta.fileName;
      }
    } catch (error) {
      // ignore invalid meta payload
    }
  }

  return "";
}
